export const RECURRING_ORDERS_RESET_STATE = 'RECURRING_ORDERS_RESET_STATE';
export const RECURRING_ORDERS_CURRENT_ITEM = 'RECURRING_ORDERS_CURRENT_ITEM';

export const RECURRING_ORDERS_REQUEST_LOADING = 'RECURRING_ORDERS_REQUEST_LOADING';
export const RECURRING_ORDERS_REQUEST_SUCCESS = 'RECURRING_ORDERS_REQUEST_SUCCESS';
export const RECURRING_ORDERS_REQUEST_FAILED = 'RECURRING_ORDERS_REQUEST_FAILED';

export const RECURRING_ORDERS_CURRENT_ACTION = 'RECURRING_ORDERS_CURRENT_ACTION';
export const RECURRING_ORDERS_RESET_ACTION = 'RECURRING_ORDERS_RESET_ACTION';
